// עריכות ידניות של פרטי לקוח (נייד, דוא"ל, כתובת, מצב משפחתי...).
// נשמרות בנפרד מהנתונים שהגיעו מקבצי המסלקה, ממוזגות מעליהם בתצוגה —
// כך עריכה שורדת טעינה מחדש של קבצים, וגם לקוחות אחזקות וגם טרום-ייעוץ נתמכים.
// המפתח: ת"ז של הלקוח (client.id מה-XML), זהה בשני המקורות.
import { memoryStore, setItemImmediate } from "./storage";

const KEY = "pension_client_overrides_v1";

export const EDITABLE_FIELDS = [
  { key: "marital",  label: "מצב משפחתי" },
  { key: "city",     label: "עיר" },
  { key: "street",   label: "רחוב" },
  { key: "houseNum", label: "מס' בית" },
  { key: "zip",      label: "מיקוד" },
  { key: "phone",    label: "טלפון" },
  { key: "mobile",   label: "נייד" },
  { key: "email",    label: "דוא\"ל" },
];

function readAll() {
  try {
    const raw = memoryStore.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch { return {}; }
}

export function getClientOverrides(clientKey) {
  if (!clientKey) return {};
  return readAll()[clientKey] || {};
}

// overrides — רק שדות שהמשתמש שינה ביחס לנתוני המקור; ערך ריק מוחק את הדריסה
export function saveClientOverrides(clientKey, overrides) {
  if (!clientKey) return;
  const all = readAll();
  const clean = {};
  for (const { key } of EDITABLE_FIELDS) {
    const v = overrides[key];
    if (v !== undefined && v !== null && String(v).trim() !== "") clean[key] = v;
  }
  if (Object.keys(clean).length > 0) all[clientKey] = clean;
  else delete all[clientKey];
  setItemImmediate(KEY, JSON.stringify(all));
}

export function applyClientOverrides(client, fallbackKey) {
  const key = client?.id || fallbackKey;
  const o = getClientOverrides(key);
  if (!Object.keys(o).length) return client;
  return { ...(client || {}), ...o };
}
